import React from "react";
import {connect} from "react-redux";
import ContentSwitcher from "./ContentSwitcher";
import 'antd/dist/antd.css';
import './App.css';
import {Button, Col, Layout, Menu, Row} from 'antd';
import Link from "redux-first-router-link";
import {triggerAuthTest, triggerLogout} from '../epics/login';
import {LOGIN} from '../reducers/router';


class App extends React.Component {

    componentWillMount = () => {
        triggerAuthTest(this.props.dispatch);
    };

    handleLogoout = () => {
        triggerLogout(this.props.dispatch);
        this.props.dispatch({
            type: LOGIN
        });
    };

    componentWillReceiveProps(nextProps) {
        if (this.props.auth && this.props.auth.authenticated && nextProps.auth.authenticated === false) {
            this.props.dispatch({
                type: LOGIN
            });
        }
    }

    render() {
        const nav = this.props.nav;
        return (
            <Layout>
                <Row type="flex">

                    <Col style={{flex: 1}}>
                        <Menu
                            theme="light"
                            mode="horizontal"
                            defaultSelectedKeys={['1']}
                            style={{lineHeight: '64px', display: 'flex'}}
                            selectedKeys={[nav.menu]}
                        >
                            {
                                nav.availableMenuEntries.map(entry =>
                                    <Menu.Item key={entry.key}>
                                        <Link to={entry.location}>{entry.name}</Link></Menu.Item>
                                )
                            }


                        </Menu>
                    </Col>
                    <Col style={{
                        justifyContent: 'center',
                        display: 'flex',
                        backgroundColor: 'white',
                        borderBottom: '1px solid #e9e9e9'
                    }}>
                        {
                            this.props.auth && this.props.auth.authenticated ?
                                <span style={{alignSelf: 'center', marginLeft: 'auto', marginRight: 10}}>
                                        <Button type="danger" onClick={this.handleLogoout}>Logout</Button></span>
                                : <div></div>
                        }
                    </Col>
                </Row>


                <div id="content">
                    <ContentSwitcher nav={nav}/>
                </div>
            </Layout>
        );
    }
}


const mapState = ({nav, auth}) => ({nav, auth});
export default connect(mapState)(App)


// WEBPACK FOOTER //
// ./src/components/App.js